import { useMutation } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import {
  CreateTwoVerificationLinkRequestType,
  CreateTwoVerificationLinkResponseType,
} from "@sellar-io/api-v2/types";

export const useCreateTwoCustomerUserVerificationLink = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CreateTwoVerificationLinkRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `two/merchant-customer/create-two-verification-link`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse<CreateTwoVerificationLinkResponseType>(response)
            .data,
      ),
    onSettled: () => {},
  });
};
